import * as Yup from "yup";



export const ROUTE_LIST = [
  { value: "BUCCEL", label: "Buccel" },
  { value: "DENTAL", label: "Dental" },
  { value: "EPIDURAL", label: "Epidural" },
  { value: "INJECTION", label: "Injection" },
];


export const VACCINE_VALIDATION = Yup.object().shape({
  vaccine: Yup.object().required().label("Vaccine Name"),
  administeredBy: Yup.object().required().label("Administered By"),
});

export const getVaccineEditFormattedPayload = (row: any) => {
  let administeredBy = undefined;

  Object.entries(row?.administeredBy ?? {})?.forEach(([value, label]) => {
    administeredBy = { value: value, label: label };
  });

  let vaccine = {
    value: row?.vaccine?.uuid,
    label: row?.vaccine?.name,
  };

  const transformedMedicationData: any = {
    ...row,
    vaccine,
    administeredBy,
  };

  return transformedMedicationData;
};
